/* os_catalog.icon.svg.js */

module.exports = {
    icon: `
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20.19 20.3" preserveAspectRatio="none">
            <path class="foreground-gl" d="M50.48.18a10.15,10.15,0,1,0,10.1,10.14A10.12,10.12,0,0,0,50.48.18ZM45,4.61h9.65a1.27,1.27,0,1,1,0,2.53H45a1.27,1.27,0,1,1,0-2.53Zm9.49,11.75H44.88a1.27,1.27,0,1,1,0-2.53h9.65a1.27,1.27,0,1,1,0,2.53ZM57.44,12h-13a1.27,1.27,0,0,1,0-2.54h13a1.27,1.27,0,0,1,0,2.54Z" transform="translate(-40.39 -0.18)"/>
        </svg>
    `
};
